module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('i', [_c('b', [_vm._v("make")])])]), _vm._v(" "), _c('p', {
    staticClass: "title_1"
  }, [_c('b', [_vm._v("The Magical Unicorn Block")])]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The Magical Unicorn block can be made in two sizes: 35˝ × 35˝ and 50˝ × 50˝.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This chapter is about making the block itself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Read Make the Quilt for information on sizes, border options, backing, and binding.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_title_1"
  }, [_c('b', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('i', [_c('b', [_vm._v("fabric")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_1t"
  }, [_vm._v("Use one or more fabrics to total the yardage listed below.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sub_title"
  }, [_c('i', [_c('b', [_vm._v("other supplies")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Freezer paper:")]), _c('br'), _vm._v("75 square foot roll")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Glue or glue stick")]), _vm._v(" for glue-basting machine appliqué")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Short appliqué pins")]), _vm._v(" for needle-turn hand appliqué")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Ultra-fine permanent marker")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "sub_1"
  }, [_vm._v("Use "), _c('i', [_vm._v("one")]), _vm._v(" of the following products to make the overlay:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Clear upholstery vinyl")]), _vm._v(" for positioning overlay (56˝ wide): 1 yard (1½ yards)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Clear medium-weight shower curtain liner")])]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('p', {
    staticClass: "back"
  }, [_c('b', [_vm._v("CUTTING")]), _vm._v(" "), _c('span', {
    staticClass: "ss"
  }, [_c('i', [_vm._v("Measurements in parentheses are for the larger block.")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_titlev"
  }, [_c('i', [_c('b', [_vm._v("Quilt base")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut or construct 1 square 39˝ × 39˝ (54˝ × 54˝).")]), _vm._v(" "), _c('p', {
    staticClass: "sub_titlev"
  }, [_c('i', [_c('b', [_vm._v("Appliqué")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut as directed.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_titlev"
  }, [_c('i', [_c('b', [_vm._v("Clear vinyl")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 1 square 36˝ × 36˝ (51˝ × 51˝) for the positioning overlay.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_title_2"
  }, [_c('b', [_vm._v("Piece the Rainbow")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rainbow has seven stripes (red, orange, yellow, green, blue, orchid, and pink) that blend into each other as they would on a color wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("If you want to piece the rainbow stripes rather than using one piece of fabric for each stripe, gather fabrics that are similar in color and value in each of the seven colors. Cut squares and/or strips from the fabrics. Work randomly, sewing pieces together in each color (there is no need to be exact). Press each new seam. Trim where needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cut and sew pieces of fabric together until the pieced unit is big enough to cut your appliqué shapes from. Treat it as you would a single piece of fabric, ironing the freezer paper template to it.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_title_2"
  }, [_c('b', [_vm._v("Appliqué the Magical Unicorn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Refer to General Instructions and Appliqué Techniques as needed. Use the appliqué patterns (see pattern sheets P1–P8).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.")]), _vm._v(" Prepare the pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2.")]), _vm._v(" Make the placement overlay and the templates.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3.")]), _vm._v(" Cut out the appliqué shapes according to the appliqué method you will use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("4.")]), _vm._v(" Use the placement overlay to place the appliqué shapes on the design wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("5.")]), _vm._v(" Appliqué the Magical Unicorn block by machine or by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("6.")]), _vm._v(" When your appliqué is complete, press the block on the wrong side. Trim away the base fabric as needed. Trim the block to 35½˝ × 35½˝ (50½˝ × 50½˝).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a77d70c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_chaptertitle1.vue
// module id = 66
// module chunks = 0